import { DATE_FORM_FORMAT } from '@/constants/date'
import moment from 'moment'
export const defaultFilters = () => ({
  pagination: {
    limit: 20,
    page: 1,
  },
  filter: {
    groupBy: 'offer',
    secondGroupBy: 'traffic_source',
    thirdGroupBy: null,
    fourthGroupBy: null,
    dateFrom: moment().format(DATE_FORM_FORMAT),
    dateTo: moment().format(DATE_FORM_FORMAT),
    advertisers: '',
    affiliateId: '',
    playerOuterId: '',
    partners: '',
    offers: '',
    countries: '',
    paymentModels: '',
    offerCategories: '',
    products: '',
    managers: '',
    subId: '',
    segment: '',
    siteId: '',
    mediaId: '',
    clickId: '',
    offerTags: '',
    partnerTags: '',
    partnerGroups: '',
    firstDeposit: null,
    landings: '',
    trafficSources: '',
    baseLine: null,
    spend: null,
    geoCountry: '',
    streams: '',
    promocode: '',
    multigeoBreakdown: 'off',
  },
  sortBy: [],
  sortDesc: [],
  sortBy1: [],
  sortDesc1: [],
  sortBy2: [],
  sortDesc2: [],
  sortBy3: [],
  sortDesc3: [],
  sortBy4: [],
  sortDesc4: [],
  clientOptions: {
    filterPanelExpanded: false,
  },
})
